const topics = [
  { name: '明星八卦', count: '128万', hot: true },
  { name: '网红黑料', count: '96万', hot: true },
  { name: '影视综艺', count: '87万', hot: true },
  { name: '社会热点', count: '76万', hot: false },
  { name: 'CP绯闻', count: '65万', hot: true },
  { name: '综艺翻车', count: '58万', hot: false },
  { name: '品牌风波', count: '52万', hot: false },
  { name: '音乐动态', count: '47万', hot: false },
  { name: '直播圈', count: '43万', hot: true },
  { name: '时尚穿搭', count: '39万', hot: false },
  { name: '二次元', count: '35万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">当下最热吃瓜讨论关键词</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.name}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium cursor-pointer transition-all duration-200 whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-600 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200/60 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
              }`}
            >
              {topic.name}
              <span className="text-xs opacity-60">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center">
                  <i className="ri-fire-line text-xs text-accent-500"></i>
                </span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}